import { BLOG_ARTICLE_CDN_BASE } from './cdn';

interface InlineMediaProps {
  cdnKey: string;
  alt: string;
}

export default function InlineMedia({ cdnKey, alt }: InlineMediaProps) {
  return (
    <img
      src={`${BLOG_ARTICLE_CDN_BASE}${cdnKey}`}
      alt={alt}
      className="article-inline-media float-left mr-6 mb-6 w-[120px] rounded-2xl lg:mr-10 lg:mb-[30px] lg:w-[180px]"
      loading="lazy"
    />
  );
}
